import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import DeleteIcon from "@material-ui/icons/Delete";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CardDelete({ itemId, deleteCard }) {
  const [open, setOpen] = useState(false);
  const handleClose = (value) => {
    if (value) {
      deleteCard(itemId);
    }
    setOpen(false);
  };
  return (
    <div>
      <DeleteIcon
        onClick={() => setOpen(!open)}
        style={{ margin: "0 0.5rem", fontSize: "20px" }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(e) => setOpen(!open)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        {/* <DialogTitle id="alert-dialog-slide-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to Delete this ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ color: "#4a5568" }}
            className="bg-green-400 text-white active:bg-gray-700 text-sm font-bold uppercaserounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
            onClick={() => handleClose(false)}
          >
            CANCEL
          </Button>
          <Button
            style={{ color: "#4a5568" }}
            className="bg-green-400 text-white active:bg-gray-700 text-sm font-bold uppercaserounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
            onClick={() => handleClose(true)}
          >
            YES
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CardDelete;
